import i18n from '@/i18n'
import api from './api'

export const BUDGET_TYPE_VALUES = {
  DAILY: 'DAILY',
  LIFETIME: 'LIFETIME'
}

export const BUDGET_TYPE_OPTIONS = [
  { label: i18n.t('BUDGET_TYPE_DAILY'), value: BUDGET_TYPE_VALUES.DAILY },
  { label: i18n.t('BUDGET_TYPE_LIFETIME'), value: BUDGET_TYPE_VALUES.LIFETIME }
]

export const OBJECTIVE_OPTIONS = [
  { label: i18n.t('OBJECTIVE_OUTCOME_APP_PROMOTION'), value: 'OUTCOME_APP_PROMOTION' },
  { label: i18n.t('OBJECTIVE_OUTCOME_AWARENESS'), value: 'OUTCOME_AWARENESS' },
  { label: i18n.t('OBJECTIVE_OUTCOME_ENGAGEMENT'), value: 'OUTCOME_ENGAGEMENT' },
  { label: i18n.t('OBJECTIVE_OUTCOME_LEADS'), value: 'OUTCOME_LEADS' },
  { label: i18n.t('OBJECTIVE_OUTCOME_SALES'), value: 'OUTCOME_SALES' },
  { label: i18n.t('OBJECTIVE_OUTCOME_TRAFFIC'), value: 'OUTCOME_TRAFFIC' },
  { label: i18n.t('OBJECTIVE_REACH'), value: 'REACH' }
]

export const OPTIMIZATION_GOAL_OPTIONS = [
  { label: i18n.t('OPTIMIZATION_IMPRESSIONS'), value: 'IMPRESSIONS' },
  { label: i18n.t('OPTIMIZATION_LANDING_PAGE_VIEWS'), value: 'LANDING_PAGE_VIEWS' },
  { label: i18n.t('OPTIMIZATION_LEAD_GENERATION'), value: 'LEAD_GENERATION' },
  { label: i18n.t('OPTIMIZATION_LINK_CLICKS'), value: 'LINK_CLICKS' },
  { label: i18n.t('OPTIMIZATION_NONE'), value: 'NONE' }
]

export const BILLING_EVENT_OPTIONS = [
  { label: i18n.t('BILLING_CLICKS'), value: 'CLICKS' },
  { label: i18n.t('BILLING_IMPRESSIONS'), value: 'IMPRESSIONS' }
]

export const PLACEMENT_OPTIONS = [
  { label: i18n.t('PLACEMENT_FACEBOOK'), id: 'facebook' },
  { label: i18n.t('PLACEMENT_INSTAGRAM'), id: 'instagram' },
  { label: i18n.t('PLACEMENT_MESSENGER'), id: 'messenger' },
  { label: i18n.t('PLACEMENT_AUDIENCE_NETWORK'), id: 'audience_network' }
]

export const FB_POSITION_OPTIONS = [
  { label: i18n.t('FB_POS_FEED'), id: 'feed' },
  { label: i18n.t('FB_POS_RIGHT_HAND_COLUMN'), id: 'right_hand_column' },
  { label: i18n.t('FB_POS_MARKETPLACE'), id: 'marketplace' },
  { label: i18n.t('FB_POS_VIDEO_FEEDS'), id: 'video_feeds' },
  { label: i18n.t('FB_POS_STORY'), id: 'story' },
  { label: i18n.t('FB_POS_SEARCH'), id: 'search' },
  { label: i18n.t('FB_POS_INSTREAM_VIDEO'), id: 'instream_video' },
  { label: i18n.t('FB_POS_FB_REELS'), id: 'facebook_reels' }
]
export const IG_POSITION_OPTIONS = [
  { label: i18n.t('IG_POS_STREAM'), id: 'stream' },
  { label: i18n.t('IG_POS_STORY'), id: 'story' },
  { label: i18n.t('IG_POS_SHOP'), id: 'shop' },
  { label: i18n.t('IG_POS_EXPLORE'), id: 'explore' },
  { label: i18n.t('IG_POS_EXPLORE_HOME'), id: 'explore_home' },
  { label: i18n.t('IG_POS_REELS'), id: 'reels' },
  { label: i18n.t('IG_POS_PROFILE_FEED'), id: 'profile_feed' }
]

export const CAMPAIGN_CTA_OPTIONS = [
  // { label: i18n.t('BOOK_APPOINTMENT'), id: 'BOOK_APPOINTMENT' },
  { label: i18n.t('BOOK_NOW'), id: 'BOOK_NOW' },
  { label: i18n.t('CONTACT_US'), id: 'CONTACT_US' },
  { label: i18n.t('EMAIL'), id: 'EMAIL' },
  { label: i18n.t('FOLLOW_PAGE'), id: 'FOLLOW_PAGE' },
  { label: i18n.t('GET_OFFER'), id: 'GET_OFFER' },
  { label: i18n.t('INTERESTED'), id: 'INTERESTED' },
  { label: i18n.t('LEARN_MORE'), id: 'LEARN_MORE' },
  { label: i18n.t('MESSAGE'), id: 'MESSAGE' },
  // { label: i18n.t('MOBILE_CENTER'), id: 'MOBILE_CENTER' },
  { label: i18n.t('REQUEST_APPOINTMENT'), id: 'REQUEST_APPOINTMENT' },
  { label: i18n.t('REQUEST_QUOTE'), id: 'REQUEST_QUOTE' },
  { label: i18n.t('SHOP_NOW'), id: 'SHOP_NOW' },
  { label: i18n.t('SIGN_UP'), id: 'SIGN_UP' }
]

const META_URL_PREFIX = '/meta/channels'

const timestamp = new Date().getTime()

export default {
  async getCampaigns () {
    const data = await api.get(`${META_URL_PREFIX}?${timestamp}`).then(res => res.data)
    return data.meta_campaigns.map(d => ({
      ...d,
      // Props for select
      label: d.name,
      value: d.id
    }))
  },
  async getCampaignDetail (campaignId) {
    const data = await api.get(`${META_URL_PREFIX}/6044773179176`).then(res => res.data)
    return data
  }
}
